export default __webpack_public_path__ + "static/BoredBot_400x650px-5bdcf548958d23273ac562f55b1cee30.png";